import {Chip, Stack, Tooltip} from "@mui/material";
import {useConfiguracaoEntrega} from "../../api/DpgeIntegracaoEsfingeApi";
import {AMBIENTE} from "../../shared/env";
import {
    obterAmbienteAplicacao,
    obterModoEnvio
} from "../../shared/modoAplicacao";

export default function ModoAplicacao() {
    const consulta = useConfiguracaoEntrega();
    return <IndicadoresModoAplicacao ambiente={AMBIENTE} consulta={consulta} />;
}

export function IndicadoresModoAplicacao({ambiente, consulta = {}}) {
    const contexto = obterAmbienteAplicacao(ambiente);
    const modo = obterModoEnvio(consulta.data, consulta);
    return (
        <Stack
            direction={{xs: "column", sm: "row"}}
            alignItems="flex-start"
            justifyContent="flex-start"
            role="region"
            aria-label="Ambiente e modo de envio"
            sx={{py: 0.75, gap: 0.75}}
        >
            <Tooltip
                arrow
                title="Ambiente definido na inicialização da interface. O destino de transmissão é configurado e validado pelo backend."
            >
                <Chip
                    size="small"
                    variant="outlined"
                    tabIndex={0}
                    color={contexto.cor}
                    label={"Ambiente: " + contexto.rotulo}
                />
            </Tooltip>
            <Tooltip arrow title={modo.descricao}>
                <Chip
                    size="small"
                    tabIndex={0}
                    color={modo.cor}
                    label={"Envio: " + modo.rotulo}
                />
            </Tooltip>
        </Stack>
    );
}
